module.exports = __webpack_public_path__ + "static/media/bg-index.f4eeb8f4.jpg";